import * as stylex from '@stylexjs/stylex';
import { borderRadius, color, spacer } from '@figma/fpl-tokens/tokens.stylex';

export const styles = stylex.create({
  control: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacer.spacer2,
  },
  triggerContent: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: spacer.spacer1,
  },
  optionContent: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: spacer.spacer2,
    height: spacer.spacer40px,
  },
  optionLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  thumbnail: {
    // The thumbnail keeps its background when the menu item is highlighted.
    '--fpl-icon-color': color.icon,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: spacer.spacer16px,
    height: spacer.spacer16px,
    overflow: 'hidden',
    borderRadius: borderRadius.small,
    backgroundColor: color.bgTertiary,
  },
  menuThumbnail: {
    width: spacer.spacer32px,
    height: spacer.spacer32px,
  },
  disabledThumbnail: {
    '--fpl-icon-color': color.iconDisabled,
  },
  thumbnailImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  weightRow: {
    display: 'flex',
    alignItems: 'center',
    gap: spacer.spacer2,
    width: '100%',
  },
  weightControl: {
    flex: 1,
    minWidth: 0,
  },
});
